module.exports = __webpack_public_path__ + "static/media/details-19-image-2.fb770078.jpg";